(function ($, Cobalt, undefined) {
    Cobalt.BulkModeration = {
        isInitialized: false,
        initialize: function () {
            if (Cobalt.BulkModeration.isInitialized) return;
            
            var _bulkModerationCookieName = $(".j-bulk-moderation").attr("data-bulk-moderation-cookie") || "selectedEntityIDs";
            
            // Store bulk moderation drop down options
            Cobalt.BulkModeration.bulkModerationOptions = $(".j-bulk-moderation select[name='actionName'] option").clone();

            // Check checkboxes based on cookie values
            var updateCheckboxes = function () {
                var entities = Cobalt.BulkModeration.getIDsFromCookie(_bulkModerationCookieName).split(',').clean();

                if (entities) {
                    // get checkboxes and make sure they are checked if in the list
                    $(":checkbox.col-actions-checkbox").each(function () { // for each checkbox on the page
                        var checkbox = $(this);
                        if ($.inArray(checkbox.val(), entities) > -1) {
                            checkbox.prop("checked", true);
                        } else {
                            // uncheck any remaining checked checkboxes
                            // Firefox checkboxes remain checked after a location.reload()
                            // This could also be solved by calling location.reload(true) (e.g. bypassing browser cache)
                            // but then the page anchor would be lost for the user
                            checkbox.prop("checked", false);
                        }
                    });
                }
            };

            Cobalt.runOnHtmlInsert(updateCheckboxes);

            // Handle CMS bulk moderation (based on ajax load)
            if ($("#image-manager").length > 0) {
                $("#image-manager").bind("onLoadComplete", updateCheckboxes);
            }

            // Update selection
            $("body").on("change", ":checkbox.col-actions-checkbox", function () {
                var checkbox = $(this);
                Cobalt.BulkModeration.saveIDsToCookie(_bulkModerationCookieName);
                var checkboxesCheckedFromOtherPages = Cobalt.BulkModeration.getIDsFromCookie(_bulkModerationCookieName).split(',').clean();
                if (!(checkbox.attr("checked"))) {
                    var index = $.inArray(checkbox.val(), checkboxesCheckedFromOtherPages);
                    if (index > -1) {
                        checkboxesCheckedFromOtherPages.splice(index, 1);
                        Cobalt.BulkModeration.setIDsToCookie(_bulkModerationCookieName, checkboxesCheckedFromOtherPages.join());
                    }
                }

                Cobalt.BulkModeration.updateBulkModerationBox();
            });

            Cobalt.BulkModeration.updateBulkModerationBox();

            $("body").on("click", ":checkbox.col-actions-select-all", function () {
                var isChecked = $(this).is(":checked");
                $(":checkbox.col-actions-checkbox").each(function () {
                    var currentState = $(this).prop("checked");
                    if (currentState != isChecked) {
                        $(this).prop("checked", isChecked);
                        $(this).trigger("change");
                    }
                });
            });

            $("body").on('click', ".j-bulk-moderation > form button[type='submit']", function (e) {
                e.preventDefault();
                var form = $(this).parents("form");
                var ajaxPost = true;

                $(".j-bulk-moderation-errors").empty();
                $(".j-bulk-moderation-errors").hide();

                var entityIDs = Cobalt.BulkModeration.getIDsFromCookie(_bulkModerationCookieName);

                var actionSelect = $(form).find("select:not(:hidden)").last().find(":selected");

                if (actionSelect.val() == "") {
                    return false;
                }

                if (entityIDs != "") {
                    var entitiesLength = entityIDs.split(",").clean().length;

                    // Specific validator for forum threads bulk moderation
                    if ($("#forum-threads").length > 0 && actionSelect.val() == 8 && entitiesLength < 2) {
                        alert("You must select at least 2 threads to perform a merge action.");
                        return;
                    }

                    //If the action is a Thread Move or Merge or in the cp submit the form instead of ajaxSubmit
                    if (($("#forum-threads").length > 0 && (actionSelect.val() == 8 || actionSelect.val() == 7)) || window.location.pathname.indexOf("/cp/") != -1) {
                        ajaxPost = false;
                    }
                    else {
                        ajaxPost = true;
                    }

                    var confirmMessage = "";
                    if ($("option#field-action-moveto").is(":selected")) {  // if this is a move-to folder action, need special text for confirm
                        confirmMessage = L.Global.ControlPanel.MovePrivateMessagesPrompt(actionSelect.text());
                    } else {
                        confirmMessage = L.Global.ControlPanel.BulkConfirm(actionSelect.text());
                    }

                    if (actionSelect.attr("data-show-confirm") === "false" || confirm(confirmMessage)) {
                        var hiddenField = $(form).find("input[name='entityIDs']");
                        if (hiddenField.length == 0) {
                            hiddenField = $("<input type=\"hidden\" name=\"entityIDs\" />");
                            $(form).append(hiddenField);
                        }
                        hiddenField.attr("value", entityIDs);
                      
                        if (ajaxPost) {
                            $(form).ajaxSubmit({
                                dataType: 'json',
                                beforeSubmit: function() {
                                    $(".j-bulk-moderation").mask();
                                },
                                success: function (data) {
                                    if (data && data.errors && data.errors.length) {
                                        for (var i = 0; i < data.errors.length; i++) {
                                            $(".j-bulk-moderation-errors").append("<li>" + data.errors[i] + "</li>");
                                        }
                                        $(".j-bulk-moderation-errors").show();
                                    }
                                    else if (data && data.html) {
                                        var modal = $('<div id="move-bulk-modal">');
                                        modal.append(data.html);
                                        
                                        modal.dialog({
                                            modal: true,
                                            height: 500,
                                            width: 600,
                                            title: data.title,
                                            resizable: false,
                                            close: function (event, ui) {
                                                modal.dialog("destroy");
                                                modal.remove();
                                            }
                                        });
                                        
                                        Cobalt.triggerHtmlInsert(modal);

                                        modal.parent().center();
                                    }
                                    else {
                                        Cobalt.BulkModeration.resetBulkModerationCookie(_bulkModerationCookieName);
                                        self.location.reload();
                                    }
                                    $(".j-bulk-moderation").unmask();
                                    
                                }
                            });
                        }
                        else {
                            $(form).submit();
                            Cobalt.BulkModeration.resetBulkModerationCookie(_bulkModerationCookieName);
                        }
                    }
                }
            });

            //clear selected
            $("body").on('click', ".j-bulk-moderation .j-clear-selection", function (e) {
                e.preventDefault();
                $(":checkbox.col-actions-checkbox").each(function () {
                    var checkbox = $(this);
                    checkbox.prop("checked", false);
                });
                Cobalt.BulkModeration.resetBulkModerationCookie(_bulkModerationCookieName);
                $(".j-bulk-moderation.toggle").hide();
            });

            
            var threadPrefixDropdownId = "#form-field-mod-prefix";
            if ($(threadPrefixDropdownId).length > 0) {
                $(threadPrefixDropdownId).addClass("hide-always");

                $("#field-action").change(function (e) {
                    var form = $(this).parents("form");
                    e.preventDefault();
                    var actionSelect = $(form).find("select:not(:hidden)").last().find(":selected");
                    if (actionSelect.val() == 11) {
                        $(threadPrefixDropdownId).removeClass("hide-always")
                    }
                    else {
                        $(threadPrefixDropdownId).addClass("hide-always");
                    }
                });
            }    
            
            Cobalt.BulkModeration.isInitialized = true;
        },
        updateBulkModerationBox: function () {
            var _bulkModerationCookieName = $(".j-bulk-moderation").attr("data-bulk-moderation-cookie") || "selectedEntityIDs";
            var checkboxesChecked = Cobalt.BulkModeration.getIDsFromCookie(_bulkModerationCookieName).split(',');
            var tempArr = new Array();
            for (var i = 0; i < checkboxesChecked.length; i++) {
                if (checkboxesChecked[i] != "") {
                    tempArr.push(checkboxesChecked[i]);
                }
            }
            checkboxesChecked = tempArr;
            $(".j-bulk-moderation").find(".j-apply-selection").text(L.Global.ContentManagement.OnSelectedTemplate(checkboxesChecked.length));
            if (checkboxesChecked.length > 0) {
                $(".j-bulk-moderation.toggle").show();
            } else {
                $(".j-bulk-moderation.toggle").hide();
            }

            var $checkboxes = $($.grep($(":checkbox.col-actions-checkbox"), function (e) { return $.inArray($(e).val(), checkboxesChecked) > -1; }));
            var $comments = $checkboxes.closest(".j-comment");
            if ($comments.length) Cobalt.BulkModeration.forumUpdateBulkModeration($comments);
        },
        forumUpdateBulkModeration: function ($comments) {
            var $options = Cobalt.BulkModeration.bulkModerationOptions;
            var $select = $(".j-bulk-moderation select[name='actionName']");
            $select.find("option").remove();

            if ($comments.filter(":not(.comment-deleted)").length) {
                $options.filter("[value='delete']").appendTo($select);
            }
            if ($comments.filter(".comment-deleted").length) {
                $options.filter("[value='undelete']").appendTo($select);
            }
            if ($comments.filter(":not(.comment-spam)").length) {
                $options.filter("[value='spam']").appendTo($select);
            }
            if ($comments.filter(".comment-spam").length) {
                $options.filter("[value='notspam']").appendTo($select);
            }
            if ($comments.length > 1) {
                $options.filter("[value='merge']").appendTo($select);
            }
            $options.filter("[value='move']").appendTo($select);

        },
        bulkModerationOptions: null,

        resetBulkModerationCookie: function (cookieName) {
            if (cookieName == undefined) {
                cookieName = "selectedEntityIDs";
            }
            var splitDomain = document.domain.split('.');
            var currentDomain = '.' + splitDomain[1] + '.' + splitDomain[2];
            $.cookie(cookieName, null, { path: "/", domain: currentDomain });
            $(".j-bulk-moderation").find(".j-apply-selection").text(L.Global.ContentManagement.OnSelectedTemplate(0));
        },
        getIDsFromCheckBoxes: function (selector) {
            var entityIDs = "";
            $(selector).each(function () {
                var entityID = $(this).val();
                if (entityIDs == "") {
                    entityIDs = entityID;
                }
                else {
                    entityIDs += "," + entityID;
                }
            });
            return entityIDs;
        },
        saveIDsToCookie: function (cookieName) {
            var IDs = Cobalt.BulkModeration.getIDsFromCheckBoxes(":checkbox.col-actions-checkbox:checked");
            var currentCookieEntities = Cobalt.BulkModeration.getIDsFromCookie(cookieName);

            if (currentCookieEntities == "") {
                Cobalt.BulkModeration.setIDsToCookie(cookieName, IDs);
            }
            else {
                var nonDuplicatedValues = (IDs + "," + currentCookieEntities).split(',').distinct();
                Cobalt.BulkModeration.setIDsToCookie(cookieName, nonDuplicatedValues);
            }
        },
        setIDsToCookie: function (cookieName, IDs) {
            var splitDomain = document.domain.split('.');
            var currentDomain = '.' + splitDomain[1] + '.' + splitDomain[2];
            var IDsWithNoNullValues;
            
            if (typeof IDs === 'string') {
                IDsWithNoNullValues = IDs.replace('null', '').replace('undefined', '');
            } else {
                IDsWithNoNullValues = IDs.filter(function(id) { return id != null; });
            }
            
            console.log(IDsWithNoNullValues)
            
            $.cookie(cookieName, IDsWithNoNullValues, { path: "/", domain: currentDomain });

        },
        getIDsFromCookie: function (cookieName) {
            var name = cookieName + "=";
            var cookies = $.cookie(cookieName);
            if (cookies) {
                return cookies;
            }
            return "";
        }
    };

})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.BulkModeration.js